import { Box, Dialog, DialogContent, DialogTitle, IconButton, Tab, Tabs } from "@mui/material";
import React, { SetStateAction, useEffect, useState } from "react";
import CreateEmbedForm from "../EmbedDrawer/CreateForm";
import Embedings from "../EmbedDrawer/Embedings";
import CloseIcon from '@mui/icons-material/Close';


interface MyComponentProps {
  openEmbed: boolean
  setOpenEmbed: React.Dispatch<SetStateAction<boolean>>
  agentId?: string
  multiAgentId?: string
}



const Embed: React.FC<MyComponentProps> = (props) => {
  
  const [tabId, setTabId] = useState(0);
  

  const handleClose = ()=>{
    props.setOpenEmbed(false)
  }

  return (<>
    <Dialog open={props.openEmbed} onClose={() => props.setOpenEmbed(false)} fullWidth maxWidth="md">

      <DialogTitle sx={{ m: 0, p: 2, position: 'relative' }}>
        Connect
        <IconButton
          aria-label="close"
          onClick={() => props.setOpenEmbed(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Tabs
        value={tabId}
        onChange={(event: React.SyntheticEvent, newValue: number) => setTabId(newValue)}
        variant="fullWidth"
      >
        <Tab label="Api Key" />
        <Tab label="Embed" />
      </Tabs>
      <DialogContent sx={{ minHeight: 400 }}>
        <Box
          sx={{
            mt: 1,
            minHeight: 400,
            height: { xs: "auto", md: 430 },
            p: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "stretch",
          }}
        >
        {tabId === 0 && (
          <CreateEmbedForm agentId={props.agentId} multiAgentId={props.multiAgentId} setTabId={setTabId} handleClose={handleClose} tabId={tabId}/>
        )}
        {tabId === 1 && (
          <Embedings  agentId={props.agentId} multiAgentId={props.multiAgentId} setTabId={setTabId} tabId={tabId}/>
        )}
        </Box>
      </DialogContent>
    </Dialog>
  </>)
}

export default Embed;
